// Actions
import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for UndoRedoStore, for use in the registry */ export const UndoRedoStoreActionTypes = [
    ActionType.PushUndoStackAction,
    ActionType.PopUndoStackAction,
    ActionType.UpdateUndoRedoEntryAction,
    ActionType.PushRedoStackAction,
    ActionType.PopRedoStackAction,
    ActionType.ClearUndoBatchEntriesAction,
    ActionType.ClearRedoStackAction,
    ActionType.PruneExpiredUndoRedoEntriesAction,
    ActionType.NavigateToView
];
